import Link from "next/link";
import { MessageSquare } from "lucide-react";
import { mountainFeedbackPath, type MountainFeedbackContext } from "@/lib/planner/feedback-context";

export function MountainFeedbackLink({ resort, sport, source }: MountainFeedbackContext) {
  return <Link href={mountainFeedbackPath({ resort, sport, source })}
    className="inline-flex min-h-11 items-center gap-2 rounded-lg px-2 text-sm font-semibold text-teal underline underline-offset-4 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal">
    <MessageSquare size={16} aria-hidden />Give map or route feedback
  </Link>;
}
